import React, { ReactNode } from 'react';

interface SocialButtonWrapperProps {
  children: ReactNode;
}

export function SocialIconWrapper({ children }: SocialButtonWrapperProps) {
  return (
    <span
      className="relative inline-flex size-8 items-center justify-center gap-2 overflow-hidden rounded-full border border-[#3436361A] text-[0px] leading-none hover:border-[#343636]"
      data-testid="blog-social-icon-wrapper"
    >
      {children}
    </span>
  );
}
